import { css } from 'styled-components'
// themes
import { colors } from 'themes/index'

export const NProgressStyles = css`
  #nprogress {
    .spinner {
      z-index: 9999;
    }

    .spinner-icon {
      border-top-color: ${colors.purple300};
      border-left-color: ${colors.purple300};
    }

    .bar {
      background: ${colors.purple300};
      height: 2px;
      z-index: 9999;
    }
  }
`
